import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitCompletenessData = createSelector(
  selectFinancialCockpitState,
  ({ completenessData }) => completenessData
)
